<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;">
        <div class="left-head">
            <el-row>
                <el-col :span="24">用户信息</el-col>
            </el-row>
        </div>
        <div class="left">
            <div class="left-flex">
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户名称：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerName"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户编号：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerCode"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户地址：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerAddr"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    联系人：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerContactPerson"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    手机号码：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerMobile"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    电子邮箱：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerEmail"></span>
                </el-col>
            </el-row>
            </div>
        </div>
        <div class="right-head">
            <el-row>
                <el-col :span="24">充值记录明细




                    <el-date-picker
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            style="width: 15vw;float: right;"
                            v-model="dateInterval"
                            @change="changeTime"
                            time-arrow-control
                            align="left"

                            :disabled="disabled"
                    >
                        <!--:picker-options="pickerOptions"-->
                    </el-date-picker>
                    <!--<el-radio-group v-model="timePeriod" size="mini"
                                    style="float: right;margin-right: 10px;"
                                    :disabled="disabled">-->
                    <el-radio-group v-model="timePeriod" size="mini"
                                    style="float: right;margin-right: 1rem;"
                                    :disabled="disabled">
                        <el-radio-button label="day">日</el-radio-button>
                        <el-radio-button label="week">周</el-radio-button>
                        <el-radio-button label="month">月</el-radio-button>
                        <el-radio-button label="year">年</el-radio-button>
                    </el-radio-group>


                    <!--<el-button size="mini" type="primary" @click="echarts('day')">查询</el-button>-->

                </el-col>

            </el-row>
        </div>
        <div class="right">
            <flex style="width: 99.99%">
                    <el-table

                            @filter-change="handleFilterChange"
                            :data="tableData"
                            size="small"
                            stripe
                            height="calc(100vh - 16rem)"
                            v-loading="loading"

                    >
                        <!--height="calc(100vh - 210px)" width="100%"-->
                        <!-- <el-table-column
                                 label="序号">
                             <template scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span></template>
                         </el-table-column>-->
                        <!--<el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item label="用户编号:" >
                                        <span>{{ props.row.customer_user_code }}</span>
                                    </el-form-item>
                                    <el-form-item label="用户地址:">
                                        <span>{{ props.row.address }}</span>
                                    </el-form-item>
                                    <el-form-item label="仪表编号:" :formatter="tableStringFormat">
                                        <span>{{ props.row.meter_code }}</span>
                                    </el-form-item>
                                    <el-form-item label="表号">
                                        <span>{{ props.row.meter_id }}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>-->
                        <el-table-column
                                label="序号"
                                align="center"
                                width="50%">
                            <template slot-scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="recharge_time"
                                label="充值时间"
                                align="center"
                                :formatter="tableTimeFormat">
                        </el-table-column>
                       <!-- <el-table-column
                                prop="customer_user_name"
                                label="用户名称"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>-->

                        <el-table-column
                                prop="meter_name"
                                label="仪表名称"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="meter_code"
                                label="仪表编号"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="meter_num"
                                label="表号"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="channel_name"
                                label="充值渠道"
                                align="center"
                                column-key="channel"
                                :filters="channelFilter"
                                :formatter="tableStringFormat
">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="type_name"
                                label="付款方式"
                                column-key="type"
                                :filters="typeFilter"
                                :formatter="tableStringFormat">
                        </el-table-column>

                        <el-table-column
                                prop="pre_balance"
                                label="表内余额(元)"
                                align="center"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="recharge_amount"
                                label="充值金额(元)"
                                align="center"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="pay_amount"
                                label="应付金额(元)"
                                align="center"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="balance"
                                label="充值后表内余额(元)"
                                align="center"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="充值状态"
                                align="center"
                                :formatter="statusFormat">
                        </el-table-column>
                        <!--<el-table-column
                                prop="operate_name"
                                label="操作人"
                                align="center"
                                :formatter="tableStringFormat">
                        </el-table-column>-->
                    </el-table>
            </flex>

                <!--<div style="width: 100%;height:30px;">-->

        </div>
        <div class="right-foot" >

            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal"
                    align="center"
                    :disabled="disabled">
            </el-pagination>




        </div>
    </div>
</template>

<script>
  import {queryCustomerById} from '@/api/customerUser'
  import { getStartAndEnd, formatDate, format } from '@/utils/time'
  import { tree, expandedCustomerWithMeter } from '@/utils/energyUtilTree'
  import { exportExcel } from '@/utils/excelUtil'
  import {getMetersByUser} from '@/api/Meter'
  import {
    rechargeRecordByPage,
    selectRechargeType,
    selectRechargeChannel
  } from '@/api/rechargeRecord'
  import Flex from "@/components/Flex";
  export default {
    name: "rechargeDetailQuery",
    components: {Flex},
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      },
      meterType(val) { //监听能源类型变化
        this.filterText = ""
        this.selectEnergyUnit()
      },
      timePeriod(val) {  //监听时间区间变化
        if (val !== null) {
          //时间框置空
          this.dateInterval = null
          if (this.meterIds.length != 0) {
            this.currentPage = 1
            this.tableByPage()
          }
        }
      },
      dateInterval(val) {    //监听时间框变化
        if (val !== null) {
          //时间区间置空
          this.timePeriod = null
          if (this.meterIds.length != 0) {
            this.currentPage = 1
            this.tableByPage()
          }
        }
      },
      meterIds(val) {    //监听仪表id变化，查询数据
        this.currentPage = 1
        this.tableByPage()
      }
    },
    data() {
      return {
        loading : false,
        tableData: [],
        excelData: [],
        channelFilter: [],
        typeFilter: [],
        timePeriod: 'month',
        dateInterval: [],
        disabled: false,
        meterIds :[],
        data: [],
        currentPage: 1,
        pageSize: 10,
        pageTotal: 1,
        timeData: [],
        customerName:"",
        customerCode:"",
        customerMobile:"",
        customerAddr:"",
        customerEmail:"",
        customerContactPerson:"",
        customerId:this.$store.getters.customerId,
        customerUserId:this.$store.getters.userId/*
        customerUserId:'0d81bf904cac40e693749f9cbecfc708'*/
      }
    },
    mounted() {
      this.queryUserInfo() //查询用户信息meterIds
      this.selectRechargeBasicInfo()
    },
    methods: {
    tableByPage() { // 数据表格分页查询，充值统计查询
      let startTime = null
      let endTime = null
      if (this.dateInterval !== null && this.dateInterval.length != 0) {  //时间框不为空使用时间框中的时间
        startTime = format(this.dateInterval[0], "YYYY-MM-DD HH:mm:ss")
        endTime = format(this.dateInterval[1], "YYYY-MM-DD HH:mm:ss")
      } else if (this.timePeriod !== null) {  //时间区间不为空则使用时间区间的时间
        let timeJson = getStartAndEnd("now", this.timePeriod)
        startTime = format(timeJson.start, "YYYY-MM-DD HH:mm:ss")
        endTime = format(timeJson.end, "YYYY-MM-DD HH:mm:ss")
      } else {  //都为空则为异常
        this.$message({
          type: 'error',
          message: '请选择查询时间'
        })
        return
      }
      let offset = (this.currentPage - 1) * this.pageSize
      //查询数据表格
      this.loading = true
      // 查询数据表格
      rechargeRecordByPage(this.meterIds, startTime, endTime, this.pageSize, offset, this.channelFilterTemp, this.typeFilterTemp, null).then(response => {
        this.tableData = response.infoJson.rows
        /*console.log(this.tableData)*/
        this.loading = false
        if (response.infoJson.total === undefined) {
          this.pageTotal = 0
        } else {
          this.pageTotal = response.infoJson.total
        }
      }).catch(error => {
        this.loading = false
        this.$message({
          type: 'error',
          message: '数据表格查询失败'
        })
        console.log(error)
      })
    },
    changeTime(time) {/*
      this.condition.startDate = time[0]
      this.condition.endDate = time[1]*/
    },handleFilterChange(filters) { // 表格筛选
      // 充值渠道筛选
      if (filters.channel !== undefined) {
        this.currentPage = 1
        this.channelFilterTemp = filters.channel
      }
      // 付款方式筛选
      if (filters.type !== undefined) {
        this.currentPage = 1
        this.typeFilterTemp = filters.type
      }
      // 查询表格数据
      this.tableByPage()
    },tableTimeFormat(row, column, cellValue) { // 表格中时间格式化
      if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
        return format(cellValue, 'YYYY-MM-DD HH:mm:ss')
      }
      return '--'
    },
    tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
      if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
        return cellValue
      }
      return '--'
    }, statusFormat(row, column, cellValue) {
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue === 0) return '支付中'
          else if (cellValue === 1 || cellValue === 5) return '充值中'
          else if (cellValue === 2) return '充值成功'
          else if (cellValue === 3) return '支付失败'
          else if (cellValue === 4) return <font style="color: red">充值失败</font>
        }
    },
    tableNumberFormat(row, column, cellValue) { // 表格中数字格式化
      if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
        return cellValue.toFixed(2)
      }
      return '--'
    }, handleSizeChange(val) { // 每页显示条数改变
      this.pageSize = val
      this.tableByPage()
    },
    handleCurrentChange(val) { // 当前页数改变
      this.currentPage = val
      this.tableByPage()
    },selectRechargeBasicInfo() { // 查询所有充值渠道、付款方式
        // 查询付款方式
        selectRechargeType().then(response => {
          const result = response.infoJson
          for (const i in result) {
            this.typeFilter.push({ 'text': result[i].rechargeType, 'value': result[i].id })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '付款方式查询失败'
          })
        })
        // 查询充值渠道
        selectRechargeChannel().then(response => {
          const result = response.infoJson
          for (const i in result) {
            this.channelFilter.push({ 'text': result[i].rechargeChannel, 'value': result[i].id })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '充值渠道查询失败'
          })
        })
      },
      queryUserInfo() { //查询用户信息
        queryCustomerById(this.customerUserId).then(response => {
          let user=response.infoJson
          if(user !== null && user!==undefined){
            if(user.realName !== null && user.realName !== undefined && user.realName !==""){
              this.customerName=user.realName
            }else{
              this.customerName="--"
            }
            if(user.name !== null && user.name !== undefined && user.name !==""){
              this.customerCode=user.name
            }else{
              this.customerCode="--"
            }
            if(user.mobile !== null && user.mobile !== undefined && user.mobile !==""){
              this.customerMobile=user.mobile
            }else{
              this.customerMobile="--"
            }
            if(user.address !== null && user.address !== undefined && user.address !==""){
              this.customerAddr=user.address
            }else{
              this.customerAddr="--"
            }
            if(user.email !== null && user.email !== undefined && user.email !==""){
              this.customerEmail=user.email
            }else{
              this.customerEmail="--"
            }
            if(user.contactPerson !== null && user.contactPerson !== undefined && user.contactPerson !==""){
              this.customerContactPerson=user.contactPerson
            }else{
              this.customerContactPerson="--"
            }
            getMetersByUser(this.customerId,this.customerUserId).then(response=>{
              if(response.code === 200)
              {
                this.meterIds = []
                const data = response.infoJson
                for(let i in data)
               {
                 this.meterIds.push(data[i].id)
               }
              }
            })

          }else{
            this.$message({
              type: 'error',
              message: '用户信息查询失败'
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '用户信息查询失败'
          })
        })
      }
    }
  }
</script>

<style scoped>
    .el-col{
        line-height: 40px;
    }
    .el-col-24{
        font-size: 15px;
        font-weight: 600;
    }
    .left{
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 0;
        width:26%;
        height:calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;
    }
    .left-flex{
        display:flex;
        flex-direction: column;
        height:calc(100% - 20px);
        width:calc(100% - 40px);
        margin: 10px 10px 10px 30px;
        font-size: 14px;
    }
    .right{
        position: absolute;
        left: 29%;
        top: 40px;
        bottom: 0;
        width:71%;
        height:calc(95% - 40px - 2rem);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;
    }
    .left-head{
        position: absolute;
        left: 0;
        width:26%;
    }
    .right-head{
        position: absolute;
        left: 29%;
        width:71%;
    }
    .right-foot{
        position: absolute;
        margin-top: 1rem;
        left: 29%;
        width:71%;
        background-color: #ffffff;
        top:calc(95% - 3rem) ;
    }
    .userInfo{
        color:#6A6A6A;
        font-size: 14px;
    }
    .userInfoValue{
        font-size: 18px;
        word-break: break-all;
        color:black;
    }
    .dialogInfo{
        line-height: 20px;
    }
</style>